import { ReactElement } from "react";
import ReactMarkdown from "react-markdown";
import { sanitizeLessonText } from "../../utils/sanitizeLessonText";

interface IProps {
  id?: number;
  title?: string;
  content?: string;
  url?: string;
  qwestion?: { q: string; answ?: string[] };
  onClickNextEx: () => void;
}

export function TextImgLesson(props: IProps): ReactElement {
  const safeTitle = sanitizeLessonText(props.title);
  const safeContent = sanitizeLessonText(props.content);
  return (
    <>
      <div className="lessonPageConteinerImgText">
        <img
          className="textConteiner-img"
          src={"/" + props.url}
          alt="lesson"
        />
        <div className="textConteiner textImgLesson">
          <h2>{safeTitle}</h2>
          <ReactMarkdown>{safeContent}</ReactMarkdown> 
        </div>
      </div>
      <div className="lessonPageOnward-button" onClick={() => props.onClickNextEx()}>
        Далее
      </div>
    </>
  );
}
